import React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

interface ConferencePreparationProps {
  studentId?: number;
  upcomingConferences?: Array<{
    id: number;
    teacherName: string;
    subject: string;
    date: string;
    type: string;
  }>;
}

export const ConferencePreparation: React.FC<ConferencePreparationProps> = ({
  upcomingConferences = [],
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Conference Preparation</CardTitle>
      </CardHeader>
      <CardContent>
        {upcomingConferences.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-gray-500">No upcoming conferences scheduled.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {upcomingConferences.map(conference => (
              <div key={conference.id} className="border rounded-lg p-4">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h4 className="font-medium">{conference.teacherName}</h4>
                    <p className="text-sm text-gray-600">
                      {conference.subject}
                    </p>
                  </div>
                  <span className="text-sm text-gray-500">
                    {conference.date}
                  </span>
                </div>
              </div>
            ))}
            <p className="text-sm text-gray-500">
              Conference scheduling and meeting links are managed by the school.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
